import { useContext, type PropsWithChildren } from "react";
import { VisualActivityContext } from "#visual-activity-context";

/** Local pagers and prepared surfaces can be hidden without changing navigation focus. */
export function VisualActivityProvider({
  active,
  children,
}: PropsWithChildren<{ active: boolean }>) {
  const parentActive = useContext(VisualActivityContext);
  return <VisualActivityContext value={parentActive && active}>{children}</VisualActivityContext>;
}
